export default __webpack_public_path__ + "static/media/woman.53da2481.jpg";